import { useDispatch, useSelector } from "react-redux"
import { useEffect, useMemo } from "react"
import { getUsers } from "../actions/auth.js"
import useStyles from '../styles/global-mui.js'
import { useTheme } from '@mui/styles';
import { Box, Chip, FormControl, InputLabel, MenuItem, OutlinedInput, Select} from '@mui/material';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
}

const SelectMultiUser = ({usersSelected = [], handleChangeUsers, provider, autoSelect = true}) => {

    const classes = useStyles();
    const theme = useTheme();

    const dispatch = useDispatch()

    const users = useSelector((state) => state.authentication).users

    useEffect(() => {
        dispatch(getUsers())
    }, [])

    // 👉 ne plus auto-sélectionner systématiquement
  useEffect(() => {
    if (!autoSelect) return;                  // on ne fait rien si autoSelect = false
    if (usersSelected.length > 0) return;     // si déjà des users choisis, on ne touche pas

    const autoSelected = users.filter(
      (u) => !provider || u.provider === provider
    );

    handleChangeUsers(autoSelected.map((u) => u._id));
  }, [provider, users, autoSelect, usersSelected, handleChangeUsers]);

    const usersDisplay = useMemo(() => {
      return users.filter(u => !provider || u.provider === provider )

    }, [users, provider])



    const handleChange = (event) => {
        let newUserSelected = event.target.value

        handleChangeUsers(newUserSelected)
    }

    return (
        <FormControl fullWidth className={classes.customInput}>
            <InputLabel id="users_label">Utilisateurs</InputLabel>
            <Select
            labelId="users_label"
            id="users_label_id"
            multiple
            input={<OutlinedInput id="select-multiple-chip" label="Utilisateurs" />}
            renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                    <Chip key={value} label={value} />
                ))}
                </Box>
            )}
            MenuProps={MenuProps}

            value={usersSelected}
            onChange={handleChange}
            >
            {usersDisplay.map(user => (
                <MenuItem
                key={user._id}
                value={user._id}
                style={getStyles(user._id, users, theme)}
                >
                    {user.name}
                </MenuItem>
            ))}
            </Select>
        </FormControl>
           )

}

export default SelectMultiUser